import React from 'react';
import * as d3 from 'd3';
// import { rgb } from 'd3-color';
import { scaleLinear } from 'd3-scale';
import {Typography} from '@material-ui/core';


export default (props) => {
  const { markers, size, color } = props;
  const leftTextWidth = 35;
  const rightTextWidth = 35;
  const adjustedWidth = size.width - (leftTextWidth + rightTextWidth);
  const lineHeight = 100;
  const lineThickness = 10;
  const markerThickness = 4;
  const circleMarkerRadius = 3;

  const markerValues = markers.map(m => +m.value);
  const max = d3.extent(markerValues)[1];

  const maxVals = [0.01,0.1,1,5,10,20,50,100,1000,10000];
  let maxStop = 0;

  for (let i=0; i < maxVals.length; i++) {
    if (max*1.1 > maxVals[i])
      maxStop = maxVals[i+1]
  }
  const scale = scaleLinear().domain([0,maxStop]).range([0,adjustedWidth]);

  const pathStartEnd = (marker) => {
    const {value,pointerPos} = marker;
    let start = { x:0, y:0 };
    let end = { x:0, y:0 };


    if (pointerPos.split('-')[0] === 'top') {
      start.y = lineHeight/2 - lineThickness/2;
      end.y = circleMarkerRadius;
    }
    if (pointerPos.split('-')[0] === 'bottom') {
      start.y = lineHeight/2  - lineThickness/2 + lineThickness*2;
      end.y = lineHeight - circleMarkerRadius;
    }
    if (pointerPos.split('-')[1] === 'left') end.x = size.width * .25 - leftTextWidth;
    if (pointerPos.split('-')[1] === 'right') end.x = size.width * .75 - leftTextWidth;

    start.x = scale(+value);

    return {start:start,end:end};
  }

  const drawPath = (start,end) => {
    return "M" + start.x + " " + start.y 
      + "C" + start.x + " " + (start.y + (end.y - start.y > 0 ? 1 : -1) * Math.abs(start.y-end.y))  + ","
      + end.x + " " + (end.y - (end.y - start.y > 0 ? 1 : -1) * Math.abs(start.y-end.y)) + ","
      + end.x + " " + end.y
  }



  return (
    <div style={{display:"flex"}}>
      <Typography variant="h6" color="primary" style={{paddingTop:(lineHeight/2-lineThickness)}}>0%</Typography>
      <div style={{paddingLeft: '10px', paddingRight: '10px'}}>
        <svg className="lineMarker" width={adjustedWidth} height={lineHeight}>
          <g className="lineMarkerG" height={lineHeight} >
            <rect 
              height={lineThickness} 
              width={adjustedWidth} 
              x={0} 
              y={lineHeight/2}
              fill={color.primary}/>
            {
              markers.map(m => {
                return <rect
                    height={lineThickness*2} 
                    width={markerThickness} 
                    x={scale(+m.value)-markerThickness/2} 
                    y={lineHeight/2 - lineThickness/2}
                    fill={color.secondary}/>
              })  
            }
            {
              markers.map(m => {
                const {start,end} = pathStartEnd(m);
                return <g>
                  <path 
                    d={drawPath(start,end)} 
                    stroke={color.secondary} 
                    fill="none" 
                    strokeWidth={1} 
                    key={"label"+m.markerPos}></path>
                  <circle
                    r={circleMarkerRadius}
                    cx={end.x}
                    cy={end.y}
                    fill={color.secondary}
                  />
                  </g>
              })  
            }
          </g>
        </svg>
      </div>
      <Typography variant="h6" color="primary" style={{paddingTop:(lineHeight/2-lineThickness)}}>{maxStop}%</Typography>
    </div>
    
  )

}